<template>
	<v-form>
      	<v-container fluid v-if="this.hotels.length">
        	<v-row >
          		<v-col>
					<p class="headline">
						Прогноз P&L
					</p>
				</v-col>
        	</v-row>
        	<v-row >
          		<v-col cols="6">
					<a-hotel-select
						v-model="hotelCode"
						:hotels="hotels"
						@change="changeHotel"
						solo>
					</a-hotel-select>
				</v-col>
          		<v-col cols="6">
					<v-menu
						v-model="monthMenu"
						:close-on-content-click="false"
						:nudge-right="40"
						transition="scale-transition"
						offset-y
						min-width="290px">
						<template v-slot:activator="{ on }">
							<v-text-field
								v-model="month"
								prepend-icon="event"
								readonly
								solo
								v-on="on"
							></v-text-field>
						</template>
						<v-date-picker
							v-model="month"
							@input="monthMenu = false"
							@change="getForecastData"
							type="month"
							:landscape="true"
							:reactive="true"
							locale="ru-ru"
							required
							:show-current="false"
							:min="minMonth"
						></v-date-picker>
					</v-menu>
				</v-col>
				<v-col cols="12">
					<v-btn
						small
						class="ma-2"
						color="primary"
						@click="copyBudget"
					>
						Копировать бюджет
					</v-btn>
					<v-btn
						small
						class="ma-2"
						color="primary"
						@click="copyLf"
					>
						Копировать прошлый прогноз
					</v-btn>
					<v-tooltip right>
						<template v-slot:activator="{ on }">
							<v-btn icon class="ml-6" :ripple="false">
								<v-icon v-on="on">
									help
								</v-icon>
							</v-btn>
						</template>
						Данные можно копировать из excel и вставлять сюда целым столбцом
					</v-tooltip>
				</v-col>
				<v-col cols="12">
					<v-data-table
						:headers="computedHeaders"
						:items="items"
						:loading="loading"
						:items-per-page="-1"
						no-data-text=""
						hide-default-header
						hide-default-footer>
						<template v-slot:header="{ props: { headers } }">
							<thead>
								<tr>
									<th v-for="header in headers"
			  							:key="header.value"
										:width="header.width"
										:class="['text-' + header.align, 'text-no-wrap']">

										<template v-if="header.value == 'bud'">
											<span class="red--text">
												Бюджет
											</span>
											/
											<span class="a" @click="compare = 'ly'">
												Прошлый год
											</span>
											/
											<span class="a" @click="compare = 'lf'">
												Прошлый прогноз
											</span>
										</template>
										<template v-else-if="header.value == 'ly'">
											<span class="a" @click="compare = 'bud'">
												Бюджет
											</span>
											/
											<span class="red--text">
												Прошлый год
											</span>
											/
											<span class="a" @click="compare = 'lf'">
												Прошлый прогноз
											</span>
										</template>
										<template v-else-if="header.value == 'lf'">
											<span class="a" @click="compare = 'bud'">
												Бюджет
											</span>
											/
											<span class="a" @click="compare = 'ly'">
												Прошлый год
											</span>
											/
											<span class="red--text">
												Прошлый прогноз
											</span>
										</template>
										<template v-else>
											{{ header.text }}
										</template>
									</th>
								</tr>
							</thead>
						</template>
						<template v-slot:item="props">
							<tr>
								<td :class="props.item.total || props.item.header ? 'font-weight-bold' : ''">
									{{ props.item.name }}
								</td>
								<td :class="[props.item.total ? 'font-weight-bold' : '', 'text-right']">
									<a-number-field-inline
										v-if="props.item.editable"
										v-model="data[props.item.block].find(el => el.name == props.item.name).fcst"
										digits="0"
										@newline="newline(props.item, $event)"
									></a-number-field-inline>
									<span v-else>{{ props.item.fcst }}</span>
								</td>
								<td>
									{{ props.item.pvFcst }}
								</td>
								<template v-if="compare == 'bud'">
									<td :class="[props.item.total ? 'font-weight-bold' : '', 'text-right text-no-wrap']">
										{{ props.item.bud }}
									</td>
									<td class="text-no-wrap">
										{{ props.item.pvBud }}
									</td>
									<td :class="[props.item.total ? 'font-weight-bold' : '', 'text-right text-no-wrap']">
										{{ props.item.difBud }}
									</td>
									<td class="text-no-wrap">
										{{ props.item.phBud }}
									</td>
								</template>
								<template v-else-if="compare == 'ly'">
									<td :class="[props.item.total ? 'font-weight-bold' : '', 'text-right text-no-wrap']">
										{{ props.item.ly }}
									</td>
									<td class="text-no-wrap">
										{{ props.item.pvLy }}
									</td>
									<td :class="[props.item.total ? 'font-weight-bold' : '', 'text-right text-no-wrap']">
										{{ props.item.difLy }}
									</td>
									<td class="text-no-wrap">
										{{ props.item.phLy }}
									</td>
								</template>
								<template v-else>
									<td :class="[props.item.total ? 'font-weight-bold' : '', 'text-right text-no-wrap']">
										{{ props.item.lf }}
									</td>
									<td class="text-no-wrap">
										{{ props.item.pvLf }}
									</td>
									<td :class="[props.item.total ? 'font-weight-bold' : '', 'text-right text-no-wrap']">
										{{ props.item.difLf }}
									</td>
									<td class="text-no-wrap">
										{{ props.item.phLf }}
									</td>
								</template>

							</tr>
						</template>
					</v-data-table>
				</v-col>
				<v-col cols="12">
					<v-textarea
						class="pl-6"
						label="Комментарии"
						autocomplete="off"
						auto-grow
						v-model="comments">
					</v-textarea>
				</v-col>
				<v-col cols="12">
					<v-btn
						color="primary"
						@click="sendForecast"
					>
						Отправить прогноз
					</v-btn>
				</v-col>
	        </v-row>
		</v-container>
	</v-form>
</template>

<style scoped>
/deep/ td.text-xs-right > .v-small-dialog > .v-menu__activator {
	display: block;
}
/deep/ td.text-xs-right > .v-small-dialog > .v-menu__activator > a {
	display: block;
	line-height: 47px;
}
.a:hover {
	cursor: pointer;
}
</style>

<script>
	import _ from 'lodash'
	import aNumberFieldInline from '../base/ANumberFieldInline.vue'
	import aHotelSelect from '../base/AHotelSelect.vue'
	import {api} from '../../lib/api'
	import {getMonthName, toNum, toStr} from '../../js/common.js'

	export default {
		components: {
			aNumberFieldInline,
			aHotelSelect
		},
		data: () => ({
			hotelCode: '',
			hotels: null,
			month: "",
			monthMenu: false,
			headers: [
				{
		            text: 'Строка',
		            align: 'left',
		            sortable: false,
		            value: 'name',
					width: "34%"
          		},
				{
		            text: 'Прогноз',
		            align: 'right',
		            sortable: false,
		            value: 'fcst',
					width: "19%"
          		},
				{
		            text: '%',
		            align: 'center',
		            sortable: false,
		            value: 'pvFcst',
					width: "3%"
          		},
				{
		            text: 'Бюджет',
		            align: 'right',
		            sortable: false,
		            value: 'bud',
					width: "19%"
          		},
				{
		            text: '%',
		            align: 'center',
		            sortable: false,
		            value: 'pvBud',
					width: "3%"
          		},
				{
		            text: 'Δ',
		            align: 'right',
		            sortable: false,
		            value: 'difBud',
					width: "19%"
          		},
				{
		            text: 'Δ %',
		            align: 'center',
		            sortable: false,
		            value: 'phBud',
					width: "3%"
          		},
				{
		            text: 'Прошлый год',
		            align: 'right',
		            sortable: false,
		            value: 'ly',
					width: "19%"
          		},
				{
		            text: '%',
		            align: 'center',
		            sortable: false,
		            value: 'pvLy',
					width: "3%"
          		},
				{
		            text: 'Δ',
		            align: 'right',
		            sortable: false,
		            value: 'difLy',
					width: "19%"
          		},
				{
		            text: 'Δ %',
		            align: 'center',
		            sortable: false,
		            value: 'phLy',
					width: "3%"
          		},
				{
		            text: 'Прошлый прогноз',
		            align: 'right',
		            sortable: false,
		            value: 'lf',
					width: "19%"
          		},
				{
		            text: '%',
		            align: 'center',
		            sortable: false,
		            value: 'pvLf',
					width: "3%"
          		},
				{
		            text: 'Δ',
		            align: 'right',
		            sortable: false,
		            value: 'difLf',
					width: "19%"
          		},
				{
		            text: 'Δ %',
		            align: 'center',
		            sortable: false,
		            value: 'phLf',
					width: "3%"
          		},
			],
			data: null,
			loading: false,
			compare: 'bud',
			roomsAvailable: {
				thisYear: 0,
				lastYear: 0
			},
			comments: ''
		}),
		computed: {
			hiddenColumns() {
				if (this.compare == 'bud') {
					return [ 'ly', 'pvLy', 'difLy', 'phLy', 'lf', 'pvLf', 'difLf', 'phLf' ]
				}
				else if (this.compare == 'ly') {
					return [ 'lf', 'pvLf', 'difLy', 'phLy', 'bud', 'pvBud', 'difBud', 'phBud' ]
				}
				else {
					return [ 'bud', 'pvBud', 'difBud', 'phBud', 'ly', 'pvLy', 'difLy', 'phLy' ]
				}
			},
			computedHeaders() {
				return this.headers.filter(h => this.hiddenColumns.indexOf(h.value) == -1)
			},
			minMonth() {
				return this.hotels.find(hotel => hotel.code == this.hotelCode).month
			},
			items() {
				// console.log('items getter')
				let items = []
				if (this.data) {


					items.push({
						header: true,
						name: 'Statistics'
					})
					items.push(...this.data.statistics.map(el => ({
						name: el.name,
						fcst: el.fcst,
						bud: el.bud,
						ly: el.ly,
						lf: el.lf,
						editable: true,
						block: 'statistics'
					})))
					let lineRoomsSold = items[1]
					items.push({
						total: true,
						name: 'Occupancy',
						fcst: toStr(toNum(lineRoomsSold.fcst) / this.roomsAvailable.thisYear * 100) + '%',
						bud: toStr(toNum(lineRoomsSold.bud) / this.roomsAvailable.thisYear * 100) + '%',
						ly: toStr(toNum(lineRoomsSold.ly) / this.roomsAvailable.lastYear * 100) + '%',
						lf: toStr(toNum(lineRoomsSold.lf) / this.roomsAvailable.thisYear * 100) + '%',
						ph: true,
					})
					items.push({
						total: true,
						name: 'ADR',
						fcst: 0,
						bud: 0,
						ly: 0,
						lf: 0,
						ph: true,
					})
					let lineAdr = items[4]

					items.push({ sep: true })

					// 6
					items.push({
						header: true,
						name: 'Operating Revenue'
					})
					items.push(...this.data.revenue.map(el => ({
						name: el.name,
						fcst: el.fcst,
						bud: el.bud,
						ly: el.ly,
						lf: el.lf,
						editable: true,
						pv: true,
						ph: true,
						block: 'revenue'
					})))
					items.push({
						total: true,
						name: 'Total Operating Revenue',
						fcst: toStr(this.data.revenue.reduce((acc, cur) => acc + toNum(cur.fcst), 0), 0),
						bud: toStr(this.data.revenue.reduce((acc, cur) => acc + toNum(cur.bud), 0), 0),
						ly: toStr(this.data.revenue.reduce((acc, cur) => acc + toNum(cur.ly), 0), 0),
						lf: toStr(this.data.revenue.reduce((acc, cur) => acc + toNum(cur.lf), 0), 0),
						pv: true,
						ph: true,
					})
					let lineRevenue = items[11]
					lineAdr.fcst = toStr(toNum(lineRevenue.fcst) / toNum(lineRoomsSold.fcst), 0)
					lineAdr.bud = toStr(toNum(lineRevenue.bud) / toNum(lineRoomsSold.bud), 0)
					lineAdr.ly = toStr(toNum(lineRevenue.ly) / toNum(lineRoomsSold.ly), 0)
					lineAdr.lf = toStr(toNum(lineRevenue.lf) / toNum(lineRoomsSold.lf), 0)

					items.push({ sep: true })

					// 13
					items.push({
						header: true,
						name: 'Departmental Expenses'
					})
					items.push(...this.data.depExpenses.map(el => ({
						name: el.name,
						fcst: el.fcst,
						bud: el.bud,
						ly: el.ly,
						lf: el.lf,
						editable: true,
						pv: true,
						ph: true,
						block: 'depExpenses'
					})))
					items.push({
						total: true,
						name: 'Total Departmental Expenses',
						fcst: toStr(this.data.depExpenses.reduce((acc, cur) => acc + toNum(cur.fcst), 0), 0),
						bud: toStr(this.data.depExpenses.reduce((acc, cur) => acc + toNum(cur.bud), 0), 0),
						ly: toStr(this.data.depExpenses.reduce((acc, cur) => acc + toNum(cur.ly), 0), 0),
						lf: toStr(this.data.depExpenses.reduce((acc, cur) => acc + toNum(cur.lf), 0), 0),
						pv: true,
						ph: true,
					})
					let lineDepExp = items[17]

					items.push({ sep: true })

					// 19
					items.push({
						header: true,
						name: 'Undistributed Expenses'
					})
					items.push(...this.data.undistExpenses.map(el => ({
						name: el.name,
						fcst: el.fcst,
						bud: el.bud,
						ly: el.ly,
						lf: el.lf,
						editable: true,
						pv: true,
						ph: true,
						block: 'undistExpenses'
					})))
					items.push({
						total: true,
						name: 'Total Undistributed Expenses',
						fcst: toStr(this.data.undistExpenses.reduce((acc, cur) => acc + toNum(cur.fcst), 0), 0),
						bud: toStr(this.data.undistExpenses.reduce((acc, cur) => acc + toNum(cur.bud), 0), 0),
						ly: toStr(this.data.undistExpenses.reduce((acc, cur) => acc + toNum(cur.ly), 0), 0),
						lf: toStr(this.data.undistExpenses.reduce((acc, cur) => acc + toNum(cur.lf), 0), 0),
						pv: true,
						ph: true,
					})
					let lineUndistExp = items[25]

					items.push({ sep: true })


					// 27
					items.push({
						total: true,
						name: 'Gross Operating Profit',
						fcst: toStr(toNum(lineRevenue.fcst) - toNum(lineDepExp.fcst) - toNum(lineUndistExp.fcst), 0),
						bud: toStr(toNum(lineRevenue.bud) - toNum(lineDepExp.bud) - toNum(lineUndistExp.bud), 0),
						ly: toStr(toNum(lineRevenue.ly) - toNum(lineDepExp.ly) - toNum(lineUndistExp.ly), 0),
						lf: toStr(toNum(lineRevenue.lf) - toNum(lineDepExp.lf) - toNum(lineUndistExp.lf), 0),
						pv: true,
						ph: true,
					})
					let lineGop = items[27]
					items.push({
						total: true,
						name: 'GOP Margin',
						fcst: lineRevenue.fcst ? toStr(toNum(lineDepExp.fcst) / toNum(lineUndistExp.fcst) * 100, 0) + '%' : '-',
						bud: lineRevenue.bud ? toStr(toNum(lineDepExp.bud) / toNum(lineUndistExp.bud) * 100, 0) + '%' : '-',
						ly: lineRevenue.ly ? toStr(toNum(lineDepExp.ly) / toNum(lineUndistExp.ly) * 100, 0) + '%' : '-',
						lf: lineRevenue.lf ? toStr(toNum(lineDepExp.lf) / toNum(lineUndistExp.lf) * 100, 0) + '%' : '-',
						ph: true,
					})

					items.push({ sep: true })

					items.push(...this.data.fees.map(el => ({
						name: el.name,
						fcst: el.fcst,
						bud: el.bud,
						ly: el.ly,
						lf: el.lf,
						editable: true,
						pv: true,
						ph: true,
						block: 'fees'
					})))
					let lineFees = items[30]

					items.push({ sep: true })

					items.push({
						total: true,
						name: 'Income Before Non-Operating Inc. & Exp.',
						fcst: toStr(toNum(lineGop.fcst) - toNum(lineFees.fcst), 0),
						bud: toStr(toNum(lineGop.bud) - toNum(lineFees.bud), 0),
						ly: toStr(toNum(lineGop.ly) - toNum(lineFees.ly), 0),
						lf: toStr(toNum(lineGop.lf) - toNum(lineFees.lf), 0),
						pv: true,
						ph: true,
					})

					items.forEach(el => {

						// проставляем вертикальные проценты

						if (el.block == 'depExpenses') {
							el.pvFcst = toStr(toNum(el.fcst) / toNum(items
								.find(ol => ol.block == 'revenue' && ol.name == el.name).fcst) * 100, 0) + '%'
							el.pvBud = toStr(toNum(el.bud) / toNum(items
								.find(ol => ol.block == 'revenue' && ol.name == el.name).bud) * 100, 0) + '%'
							el.pvLy = toStr(toNum(el.ly) / toNum(items
								.find(ol => ol.block == 'revenue' && ol.name == el.name).ly) * 100, 0) + '%'
							el.pvLf = toStr(toNum(el.lf) / toNum(items
								.find(ol => ol.block == 'revenue' && ol.name == el.name).lf) * 100, 0) + '%'
						}
						else if (el.pv) {
							el.pvFcst = toStr(toNum(el.fcst) / toNum(lineRevenue.fcst) * 100, 0) + '%'
							el.pvBud = toStr(toNum(el.bud) / toNum(lineRevenue.bud) * 100, 0) + '%'
							el.pvLy = toStr(toNum(el.ly) / toNum(lineRevenue.ly) * 100, 0) + '%'
							el.pvLf = toStr(toNum(el.lf) / toNum(lineRevenue.lf) * 100, 0) + '%'
						}

						// проставляем горизонтальные проценты

						if (el.ph) {
							el.difBud = toNum(el.fcst) - toNum(el.bud)
							el.phBud = toStr(el.difBud / toNum(el.fcst) * 100, 0) + '%'
							el.difBud = toStr(el.difBud, 0)

							el.difLy = toNum(el.fcst) - toNum(el.ly)
							el.phLy = toStr(el.difLy / toNum(el.fcst) * 100, 0) + '%'
							el.difLy = toStr(el.difLy, 0)

							el.difLf = toNum(el.fcst) - toNum(el.lf)
							el.phLf = toStr(el.difLf / toNum(el.fcst) * 100, 0) + '%'
							el.difLf = toStr(el.difLf, 0)
						}
					})
				}
				return items
			},
		},
		created() {
			if (this.$store.getters.userHo) {
				this.hotels = this.$store.getters.allHotels
			}
			else {
				this.hotels = this.$store.getters.userHotels
			}

			this.hotelCode = this.hotels[0].code

			api.post('pl/get_pending_report_month', { hotels: this.hotels })
			.then(response => {
				this.hotels = response.data.hotels

				if (this.hotels.length) {
					let selHotelCode = this.$store.getters.selectedHotelCode
					if (selHotelCode && this.hotels.find(el => el.code == selHotelCode)) {
						this.hotelCode = selHotelCode
					}
					else {
						this.$store.dispatch('setSelectedHotelCode', this.hotelCode)
					}

					this.changeHotel()
				}

			}, error => {})
		},
		mounted() {

		},
		methods: {
			newline(item, val) {
				// console.log('newline')
				// console.log('val', val)
				// console.log('item', item)
				// console.log('this.items', this.items)

				let delimeter = '\n'
				let arr = val.split(delimeter)
				// console.log('arr', arr)

				let start = this.items.findIndex(el => el.block == item.block && el.name == item.name)
				// console.log('start', start)

				for (let i = start + 1; i < this.items.length; i++) {
					// console.log('i', i)
					// console.log('items[i]', this.items[i])
					// console.log('arr.length', arr.length)

					if (arr.length == 0) break

					if (this.items[i].editable) {
						let cut = arr.shift()
						// console.log(cut)

						this.data[this.items[i].block].find(el => el.name == this.items[i].name).fcst = cut
					}
				}
			},
			changeHotel() {
				this.month = this.minMonth
				this.getForecastData()
			},
			getForecastData() {
				// console.log('getForecastData')
				this.loading = true
				api.post('pl/forecast/get_forecast_data', {
					hotelCode: this.hotelCode,
					month: this.month
				})
				.then(response => {

					this.data = response.data.data
					for (let group in this.data) {
						this.data[group].forEach(el => {
							el.lf = el.fcst
						})
					}
					this.roomsAvailable = response.data.roomsAvailable
					this.loading = false
					// console.log(this.data)

				}, error => {})
			},
			copyBudget() {
				for (let group in this.data) {
					this.data[group].forEach(el => {
						el.fcst = el.bud
					})
				}
			},
			copyLf() {
				for (let group in this.data) {
					this.data[group].forEach(el => {
						el.fcst = el.lf
					})
				}
			},
			sendForecast() {
				this.$store.dispatch('dialogConfirm', {
					title: 'Подтверждение',
					message: 'Прогноз будет отправлен GM, в управляющую компанию и другим получателям прогнозных P&L, указанным в параметрах отеля.<br><br>'
						+ '<table >'
						+ '<tr>'
						+ '<td style="padding: 2px 5px;">ADR:</td>'
						+ '<td style="padding: 2px 5px;">' + this.items[4].fcst + '</td>'
						+ '</tr><tr>'
						+ '<td style="padding: 2px 5px;">Total Revenue:</td>'
						+ '<td style="padding: 2px 5px;">' + this.items[11].fcst + '</td>'
						+ '</tr><tr>'
						+ '<td style="padding: 2px 5px;">GOP:</td>'
						+ '<td style="padding: 2px 5px;">' + this.items[27].fcst + '</td>'
						+ '</tr>'
						+ '</table><br>'
						+ (this.comments == '' ? 'Комментарий отсутствует' : '')

				})
				.then(confirm => {
					if (confirm) {
						this.$store.dispatch('dialogLoadingStart')

						let data = {}

						for (let group in this.data) {
							data[group] = []
							this.data[group].forEach(el => {
								data[group].push({
									fcst: el.fcst,
									dc: el.dc,
									ic: el.ic
								})
							})
						}

						api.post('pl/forecast/set_forecast_data', {
							hotelCode: this.hotelCode,
							month: this.month,
							data: data,
							comments: this.comments
						})
						.then(response => {

							this.getForecastData()
							this.comments = ''

							this.$store.dispatch('dialogLoadingStop')
							this.$store.dispatch('dialogNotify', {
								title: 'Готово',
								message: 'Прогноз успешно отправлен'
							})
						}, error => {})
					}
				})
			},
		}
	}
</script>
